/*
@license
Utils by Antony
*/

function wipeRep(str) {
    const REP_REG = /\(REP.*\)/g
    return str.replace(REP_REG, '')
}

function replaceSymbolText(str) {
    str = str.replace('«', '.5').replace('Â½', '.5').replace('½', '.5').replace('�', '.5');
    return str;
};

function desku(sku, last_ref) {
    // Pre-process: With prefex(s)
    // ignore placeholder (REP)
    sku = replaceSymbolText(sku);
    //let sku_post = sku.replace("(REP)",'')
    let sku_post = wipeRep(sku);
    // sku_post = replaceSymbol(sku_post) // Get rid of T2T symbol
    let model = '';
    let name_type = '';
    const skuParts = sku.split('-');
    if (skuParts.length > 1) {
        switch (skuParts.length) {
            case 2: // 2 parts
                const first_part = skuParts[0];
                if (first_part.length == 1 && /^[a-zA-Z]/.test(first_part)) {
                    //Start with A- or single alphabet
                    sku_post = skuParts[1];
                    name_type = 'A prefix';
                } else if (/^[a-zA-Z]\d{6}/.test(first_part)) {
                    // Alphabet + 6 digits
                    sku_post = skuParts[1];
                    name_type = 'B + Ref Prefix';
                } else if (/^[a-zA-Z\s]+\d{6}/.test(first_part)) {
                    //Colour + 6 digits
                    sku_post = skuParts[1];
                    name_type = 'Colour + Ref Prefix';
                } else if (/^(([1-9]\d*\.?\d*)|(0\.\d*[1-9])|ONE|ANY|PAC|L|M|S|XL|XXL)+[a-zA-Z\s]+\d{6}/.test(first_part)) {
                    // with Model postfix
                    model = skuParts[1];
                    sku_post = sku.substring(0, sku.length - model.length - 1); // remove Model Postfix
                    name_type = 'Model Postfix';
                } else if (/^[a-zA-Z\s]+/.test(first_part)) {
                    // Supplier Prefix
                    sku_post = skuParts[1];
                    name_type = 'Supplier Prefix';
                } else {
                    name_type = 'Not detected';
                }
                break;

            case 3:
                const third_part = skuParts[2];
                if (/^(([1-9]\d*\.?\d*)|(0\.\d*[1-9])|ONE|ANY|PAC|L|M|S|XL|XXL)+[a-zA-Z\s]+\d{6}/.test(third_part)) {
                    // A-X Prefix Naming
                    sku_post = skuParts[2];
                    name_type = 'A-X Prefix';
                }
                break;

            default:
                break;
        }
    } else {
        name_type = 'Whole Bunch';
    }

    // Regex for Size Prefix (w/o point)
    //console.log(sku)
    const regex_size = /^(([1-9]\d*\.?\d*)|(0\.\d*[1-9])|ONE|ANY|PAC|L|M|S|XL|XXL)/; // numberic or ONE SIZE
    // Extract Size
    const size_exec_arr = regex_size.exec(sku_post);
    let size = '';
    if (size_exec_arr) {
        size = size_exec_arr[0];
        // Post Fix Size (only dot)
        if (size.charAt(size.length - 1) === '.') {
            size = size + '5'; //Fix the error size
        }
        // check real size
        const size_num = parseInt(size);
        if (size_num >= 1000) size = '';
    }

    // Trim sku
    const sku_trim_1 = sku_post.substring(size ? size.length : 0);
    // console.log(sku_trim_1)

    // Regex for Color (Words)
    const regex_color = /^[\w\s]+(?=\d{6})/;
    let color = '';
    const color_exec_arr = regex_color.exec(sku_trim_1);
    if (color_exec_arr) {
        color = color_exec_arr[0];
    }

    // Trim sku
    const sku_trim_2 = sku_trim_1.substring(color ? color.length : 0);
    // console.log(sku_trim_2)

    // Regex for Ref ID
    const regex_ref = /^\d{6}/;
    const regex_ref_broad = /\d{6}/;
    let ref_id = '';
    const ref_exec_arr = regex_ref.exec(sku_trim_2);
    if (ref_exec_arr) {
        ref_id = ref_exec_arr[0].toString();
    } else {
        // Broad Match
        const ref_exec_match_arr = regex_ref_broad.exec(sku_trim_2);
        const ref_exec_fullmatch_arr = regex_ref_broad.exec(sku);
        if (ref_exec_match_arr) {
            ref_id = ref_exec_match_arr[0].toString();
        } else if (!ref_exec_match_arr && ref_exec_fullmatch_arr) {
            ref_id = ref_exec_fullmatch_arr[0].toString();
        }
    }
    // console.log('Ref ID: ' + ref_id)
    // console.log('Type Size: ' + typeof(size))
    // console.log('Type Color: ' + typeof(color))
    // console.log('Type Ref ID: ' + typeof(ref_id))

    // Trim sku (residue)
    const sku_residue = sku_trim_2.substring(ref_id ? ref_id.length : 0);

    // Check RefID
    const ref_id_num = ref_id ? parseInt(ref_id) : 999999; // MAX_NUM
    const last_id_num = last_ref ? last_ref : 999999; // MAX_NUM

    if (ref_id && ref_id_num < last_id_num) {
        return {
            sku: sku,
            size: size,
            color: color,
            ref_id: ref_id,
            model: model,
            residue: sku_residue,
            name_type: name_type,
            proper_sku: 'A-' + size + color + ref_id,
        };
    } else if (ref_id) {
        console.warn('RefID Out of bound: ' + sku + '. Please check it manually.');
        return {
            sku: sku,
            size: size,
            color: color,
            ref_id: ref_id,
            model: model,
            residue: sku_residue,
            name_type: name_type + ' (Out of bound, failed)',
        };
    } else {
        // Failed to decompose
        console.warn('Failed to decomposed SKU: ' + sku + '. Please do it manually.');

        return {
            sku: sku,
            size: size,
            color: color,
            ref_id: ref_id,
            model: model,
            residue: sku_residue,
            name_type: name_type + ' (Failed)',
        };

        /* Bad
              DecomposedSKUSheetWriter.getCell('A1').fill = {
                type: 'gradient',
                gradient: 'path',
                center: { left: 0, top: 1 },
                stops: [
                  { position: 0, color: { argb: 'FF107C41' } },
                  { position: 1, color: { argb: 'FF107C41' } }
                ]
              }
            */
    }
}
